import { Helmet } from "react-helmet-async";
import SectionHeader from "../components/SectionHeader";

export default function About() {
  return (
    <main className="page-top section-padding">
      <Helmet><title>About | VRGlobal Tech</title></Helmet>
      <div className="container">
        <div className="row align-items-center gy-5">
          <div className="col-lg-6">
            <SectionHeader center={false} eyebrow="About Us" title="We build technology that helps businesses work smarter" text="VRGlobal Tech is a professional software and digital services brand focused on ERP applications, websites, SEO, servers, hosting, domains and advertising solutions." />
            <p className="text-soft fs-5">Our goal is to provide clean design, secure code, reliable deployment and practical business automation for companies of all sizes.</p>
          </div>
          <div className="col-lg-6">
            <div className="about-panel">
              <h4>Our strengths</h4>
              {[
                "Business-focused ERP modules",
                "Modern responsive web design",
                "Secure ASP.NET Core and React architecture",
                "SEO and digital growth planning",
                "Server, domain and hosting expertise"
              ].map((x) => <div className="feature-line" key={x}><i className="bi bi-stars"></i>{x}</div>)}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
